import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=29893b1e&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"
import style0 from "./permissions.vue?vue&type=style&index=0&id=29893b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29893b1e",
  null
  
)

export default component.exports